
import { matchMedia } from 'window';

import ko from 'knockout';
import $ from 'jquery';

import 'rgs-bootstrap';

import Velocity from 'rgs-velocity-animate';


// Bootstrap datepicker
ko.bindingHandlers.bsDatepicker = {
	init: function (element, valueAccessor) {
		function getOptions () {
			return valueAccessor() || {};
		}
		const $element = $(element);
		const options = getOptions();
		$element.datepicker(options);

		// event to prevent scrolling by default on mobile devices
		$element.on('touchend', e => {
			e.preventDefault();
			$element.trigger('mousedown');
			$element.trigger('click');
		});

		$element.on('click', () => {
			$element.datepicker('show');

			if (options.mobileScroll
				&& matchMedia('(max-width: 619px)').matches
				&& !$('.datepicker-orient-top').length
			) {
				setTimeout(() => {
					Velocity.animate($element, 'scroll', { offset: -30 });
				}, 100);
			}
		});

		// TODO: automatically map all options to their setters

		ko.computed(function () {
			const options = getOptions();
			if (options.date) {
				$element.datepicker('setDate', options.date);
			}
		}, null, { disposeWhenNodeIsRemoved: element });

		ko.computed(function () {
			const options = getOptions();
			$element.datepicker('setStartDate', options.startDate);
		}, null, { disposeWhenNodeIsRemoved: element });

		ko.computed(function () {
			const options = getOptions();
			$element.datepicker('setEndDate', options.endDate);
		}, null, { disposeWhenNodeIsRemoved: element });

		ko.utils.domNodeDisposal.addDisposeCallback(element, () => $element.off());
	},
};
